<script setup lang="ts">
import { PPopover, PPopoverContent, PPopoverTrigger, PButton } from '@pokerly/ui';
import { computed } from 'vue';
import { DEFAULT_ESTIMATION_OPTIONS } from '@/config/session-config.ts';

const emit = defineEmits<{
    select: [value: string | number];
}>();
const columns = computed(() => Math.ceil(Math.sqrt(DEFAULT_ESTIMATION_OPTIONS.length)));
</script>

<template>
    <PPopover>
        <PPopoverTrigger as-child>
            <slot />
        </PPopoverTrigger>
        <PPopoverContent class="w-80">
            <div class="grid gap-2" :style="{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }">
                <PButton
                    variant="ghost"
                    size="lg"
                    v-for="value in DEFAULT_ESTIMATION_OPTIONS"
                    :key="value"
                    @click="emit('select', value)"
                >
                    <span class="font-bold text-2xl">
                        {{ value }}
                    </span>
                </PButton>
            </div>
        </PPopoverContent>
    </PPopover>
</template>
